import React from 'react';
import styled from '@emotion/styled';

import { parseHtml } from '../helpers';

import { ProductComponentProps } from '../../types/types';

import VerticalSplit from '../shared/containers/VerticalSplit';
import { CostHeader } from './CostHeader';
import { CostPoints } from './CostPoints';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { pxToRem, mqBreakpoints } = StyleLibrary;

import { productComponentContainerPaddingStyle, productComponentContainerBottomPaddingStyle } from '../shared/styles';

const CostPointsContentContainer = styled.div(productComponentContainerPaddingStyle, productComponentContainerBottomPaddingStyle);

const CostContentContainer = styled.div(productComponentContainerPaddingStyle, productComponentContainerBottomPaddingStyle, {
  alignItems: 'flex-start',
  backgroundColor: 'var(--color-secondary)',
  justifyContent: 'flex-start',
});

const H2 = styled.h2({
  fontWeight: 'var(--font-weight-regular)',
});

const P = styled.p({
  fontWeight: 'var(--font-weight-light)',
  marginTop: pxToRem(-16),

  [mqBreakpoints.desktop]: {
    marginTop: pxToRem(-40),
  },
});

export const Cost: React.FC<ProductComponentProps> = props => {
  const { title, description, points, price } = props.productComponent;
  const componentIdx = props.index ?? 0;

  return (
    <VerticalSplit id={`mp-product-cost-${componentIdx}`} rowReverse={true} data-testid='mp-product-cost'>
      <CostContentContainer>
        {description && <h6 data-testid='mp-product-cost-description'>{parseHtml(description)}</h6>}
        <H2 className='display-3 numeric' data-testid='mp-product-cost-amount'>
          {parseHtml(price.amount)}
        </H2>
        <P data-testid='mp-product-cost-frequency'>
          <small>{parseHtml(price.frequency)}</small>
        </P>
      </CostContentContainer>

      <CostPointsContentContainer>
        <CostHeader title={title} />
        <CostPoints points={points} />
      </CostPointsContentContainer>
    </VerticalSplit>
  );
};
